import React from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';

// Hooks
import { useSmac } from 'Shared/utils/hooks/use-smac';

// Components
import MembersTable from './MembersTable';
import UserManagementOrganization from './UserManagementOrganization';
import Pi2AdminRedirectMessage from './Pi2AdminRedirectMessage';
import PiAdminConsoleIntroModal from 'Dashboard/components/PiAdminConsoleIntroModal/PiAdminConsoleIntroModal';

// Styles
import './MembersManagement.scss';

const MembersManagement = () => {
  const { enablePerformOrgManagement } = useFlags();
  const { hasPi2Access, isStandAlone } = useSmac();
  const showPiAdminView = enablePerformOrgManagement && (isStandAlone || hasPi2Access);

  const baseClassName = 'MembersManagement';

  return (
    <>
      <div>
        <div className={`${baseClassName}__section`}>
          <UserManagementOrganization />
        </div>
        <div className={`${baseClassName}__section`}>
          {showPiAdminView ? <Pi2AdminRedirectMessage /> : <MembersTable />}
        </div>
      </div>
      {showPiAdminView && <PiAdminConsoleIntroModal />}
    </>
  );
};

export default MembersManagement;
